export const getUserSSEUrl = (baseUrl: string) => {
  const userSSEUrl = `${baseUrl}/user/sse`
  return {
    GET_USER_SSE_URL: userSSEUrl
  }
}
